import { styled } from '@mui/material';

import { ButtonsContainer, Button, Alert } from '@app-velocity/ui';

import { useI18n } from '@app-velocity/i18n';

import {
  ReportCardSkeletons,
  useMyReportsContext,
} from '@app-velocity/libs/report';

import { NoReports } from '../NoReports';
import { SingleReportCard } from '../SingleReportCard';

const Challenges = styled('div')(({ theme }) => ({
  flexWrap: 'wrap',
  gap: theme.spacing(2),
  display: 'grid',
  '@media screen and (min-width: 1024px)': {
    gridTemplateColumns: '1fr 1fr',
  },
  '@media screen and (min-width: 1440px)': {
    gridTemplateColumns: '1fr 1fr 1fr',
  },
}));

export const FigmaReportsList = () => {
  const { t } = useI18n();
  const {
    figmaPrototypes,
    hasMoreFigmaReports,
    isFetchingMoreFigmaReports,
    fetchMoreFigmaReports,
    isFigmaLoading,
    figmaFilters,
  } = useMyReportsContext();

  const { file, page, flow, owner, from, to, date, category } = figmaFilters;

  const anyFilterOn =
    file ||
    page ||
    flow ||
    category ||
    (owner && owner !== 'own') ||
    date ||
    from ||
    to;

  if (isFigmaLoading) {
    return (
      <Challenges>
        <ReportCardSkeletons />
      </Challenges>
    );
  }

  if (figmaPrototypes.length === 0 && !anyFilterOn) {
    return <NoReports />;
  }

  if (figmaPrototypes.length === 0) {
    return (
      <Alert severity="info">{t('users:reports.no_matching_reports')}</Alert>
    );
  }

  return (
    <>
      <Challenges>
        {figmaPrototypes.map((scenario) => (
          <SingleReportCard prototype={scenario} key={scenario.id} />
        ))}
        {isFetchingMoreFigmaReports ? <ReportCardSkeletons /> : null}
      </Challenges>
      {hasMoreFigmaReports ? (
        <ButtonsContainer align="center">
          <Button
            variant="contained"
            color="secondary"
            onClick={() => fetchMoreFigmaReports()}
            disabled={isFetchingMoreFigmaReports}
          >
            {t('shared:show_more')}
          </Button>
        </ButtonsContainer>
      ) : null}
    </>
  );
};
